import { render, staticRenderFns } from "./ClubList.vue?vue&type=template&id=38b85949&scoped=true"
import script from "./ClubList.vue?vue&type=script&lang=js"
export * from "./ClubList.vue?vue&type=script&lang=js"
import style0 from "./ClubList.vue?vue&type=style&index=0&id=38b85949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b85949",
  null
  
)

export default component.exports